<template>
  <div
    id="filter-navigation"
    class="bg-blackly flex h-16 fluid-xs leading-tightest text-white border-t border-gray-divider-darker"
  >
    <div class="md:container w-full">
      <div class="border-gray-divider-darker flex flex-row h-full border-l border-r">
        <div
          class="md:shadow-none whitespace-nowrap flex items-center mr-auto overflow-x-auto shadow-inner exercise-nav"
        >
          <div class="md:block hidden ml-4 mr-6 font-medium uppercase">{{ $t('exercises.view') }}</div>
          <nuxt-link
            v-for="{ title, uri } in pages"
            :key="uri"
            :to="{ path: $localeRootPath(uri) }"
            :class="{
              'bg-charcoal': !isCurrent($localeRootPath(uri)),
              'text-charcoal bg-br-green-light': isCurrent($localeRootPath(uri)),
            }"
            class="text-br-green-light hover:bg-br-green-light hover:text-charcoal px-4 py-1 ml-4 font-medium rounded-full outline-br-green!"
            >{{ title }}</nuxt-link
          >
        </div>
        <div class="border-gray-divider-darker flex flex-row h-full border-l">
          <button
            id="options-menu"
            data-test-id="btn-filter-toggle"
            type="button"
            class="text-br-green-light hover:text-white focus:border-blue-300 focus:ring-1 focus:ring-blue flex items-center justify-between w-full h-full px-6 fluid-xs leading-tightest uppercase transition duration-150 ease-in-out focus-visible:focus-ring-inside outline-br-green!"
            :aria-expanded="isFilterAreaVisible.toString()"
            aria-controls="filter-area"
            :aria-label="isFilterAreaVisible ? $t('exercises.hideFilters') : $t('exercises.showFilters')"
            aria-haspopup="true"
            @click="filterToggle"
          >
            <div class="font-medium">{{ $t('exercises.filters') }}</div>
            <DropdownIndicatorIcon :down="!isFilterAreaVisible" class="block ml-4 h-1.5 -mr-1" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isFiltersQuery } from '@/utils/algolia';
import DropdownIndicatorIcon from '@/components/icons/DropdownIndicatorIcon';
import ResetIcon from '@/components/icons/ResetIcon';
import { Bus } from '@/utils/bus';

export default defineNuxtComponent({
  components: {
    ResetIcon,
    DropdownIndicatorIcon,
  },
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFilterSectionVisible: null,
    };
  },
  computed: {
    isFiltersQuery() {
      return isFiltersQuery(this.$route.query);
    },
    isFilterAreaVisible() {
      return this.isFilterSectionVisible !== null ? this.isFilterSectionVisible : this.isFiltersQuery;
    },
  },
  mounted() {
    Bus.on('exercisesFilterVisibilityChanged', (isVisible) => {
      this.isFilterSectionVisible = isVisible;
    });
  },
  beforeUnmount() {
    Bus.off('exercisesFilterVisibilityChanged');
  },
  methods: {
    isCurrent(path) {
      return this.$route.path === path;
    },
    filterToggle() {
      Bus.emit('exercisesFilterToggle');
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.exercise-nav {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
}
.exercise-nav::-webkit-scrollbar {
  @apply hidden;
}
</style>
